import { z } from "zod";

/*
 * In-panel notifications (docs/budgets.md): the bell in the top bar. Each
 * belongs to one person; the panel writes the text from `kind` and `data`.
 * E-mail and Telegram come later, over the same records.
 */

export const NotificationKind = z.enum([
  /** A budget threshold was reached: `{threshold, basis, percent, amount, budget, currency, month}`. */
  "budget.threshold",
  /** A project owner asked for a raise: `{raiseId, amount, raiseKind, currency, requestedBy}`. */
  "budget.raise_requested",
  /** An administrator decided a raise: `{raiseId, amount, raiseKind, currency, decision}`. */
  "budget.raise_decided",
  /** A key's call waits for approval (docs/approvals.md): `{approvalId, action, keyName, targetName}`. */
  "approval.requested",
  /** A person decided it, or it ran: `{approvalId, action, keyName, targetName, decision}`. */
  "approval.decided",
]);
export type NotificationKind = z.infer<typeof NotificationKind>;

export const Notification = z.object({
  id: z.uuid(),
  kind: NotificationKind,
  projectId: z.uuid().nullable(),
  projectName: z.string().nullable(),
  data: z.record(z.string(), z.union([z.string(), z.number(), z.null()])),
  createdAt: z.iso.datetime(),
  readAt: z.iso.datetime().nullable(),
});
export type Notification = z.infer<typeof Notification>;

/** `GET /notifications`: the newest ones and how many are unread. */
export const NotificationList = z.object({
  items: z.array(Notification),
  unread: z.number().int().nonnegative(),
});
export type NotificationList = z.infer<typeof NotificationList>;

/** `POST /notifications/read`: these, or all when `ids` is left out. */
export const MarkNotificationsRequest = z.object({ ids: z.array(z.uuid()).max(100).optional() });
export type MarkNotificationsRequest = z.input<typeof MarkNotificationsRequest>;
